import { EventType } from '@bit-by-bit-software/types';
import CircularProgress from '@mui/material/CircularProgress';
import DialogContent from '@mui/material/DialogContent';
import FormControl from '@mui/material/FormControl';
import Grid from '@mui/material/GridLegacy';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Paper from '@mui/material/Paper';
import Select from '@mui/material/Select';
import Typography from '@mui/material/Typography';
import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react';

import { AppText } from '../../constant';
import { ApiManager } from '../../managers';
import Container from './Container';
import { AlertContext } from '@bit-by-bit-software/ui';

function Reports() {
  const { showAlert } = useContext(AlertContext);

  const [isLoading, setIsLoading] = useState<boolean>();
  const [event, setEvent] = useState<EventType>();
  const [events, setEvents] = useState<EventType[]>([]);
  const [report, setReport] = useState<any>();

  const loadData = useCallback(
    async (eventToUse: EventType | undefined = undefined) => {
      try {
        setIsLoading(true);
        const response = await ApiManager.SendRequest<{
          events: any[];
          activeEvent: any;
        }>({
          route: 'classy',
          action: 'report',
          params: {
            event: eventToUse?._id,
          },
        });

        if (response.error) {
          showAlert({
            headerText: 'Uh-oh',
            detailText: response.error,
            variant: 'danger',
            dismissText: 'okay',
          });
          return;
        }

        setEvent(response.activeEvent);
        setEvents(response.events);
        setReport(response.results);
      } catch (err: any) {
        showAlert({
          headerText: 'Uh-oh',
          detailText: `An error has occurred, please try again or contact support.\nError: ${err.emssage}`,
          variant: 'danger',
          dismissText: 'okay',
        });
      } finally {
        setIsLoading(false);
      }
    },
    [showAlert],
  );

  const reportFields = useMemo(() => (report ? Object.keys(report) : []), [report]);

  useEffect(() => {
    loadData();
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, []);

  return (
    <Paper>
      <Container>
        <Typography variant="h3" classes={{ h3: 'friends-title' }} display="block" align="center">
          {AppText.reports.title}
        </Typography>
        {isLoading ? <CircularProgress /> : null}
        <DialogContent /* dividers */ className="friends-content">
          <Grid container direction="row">
            <Grid item xs={6}>
              {reportFields.map(reportKey => (
                <Grid
                  key={reportKey}
                  container
                  direction="row"
                  style={{ marginTop: '25px', marginBottom: '25px' }}>
                  <Grid item xs={12}>
                    <Typography
                      variant="h5"
                      classes={{ h5: 'preview-title' }}
                      display="block"
                      align="left">
                      {report?.[reportKey]?.description}
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="body2" classes={{ body2: 'info-message' }} align="left">
                      {report?.[reportKey]?.value}
                    </Typography>
                  </Grid>
                </Grid>
              ))}
            </Grid>
            <Grid item xs={6}>
              <FormControl className="select-control">
                <InputLabel className="select-label" id="job-select-label">
                  Event
                </InputLabel>
                <Select
                  labelId="job-select-label"
                  id="job-select"
                  value={event?._id?.toString() ?? ''}
                  onChange={e => {
                    let theEvent: EventType | undefined;
                    for (let i = 0; i < events.length; i++) {
                      if (events[i]._id.toString() === e.target.value) {
                        theEvent = events[i];
                        break;
                      }
                    }

                    setEvent(theEvent);
                    loadData(theEvent);
                  }}>
                  {events.map(event => (
                    <MenuItem key={`event-${event._id.toString()}`} value={event._id?.toString()}>
                      {event.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </DialogContent>
      </Container>
    </Paper>
  );
}

export default Reports;
